import { useEffect, useRef, useState } from 'react'
import { useSetState, useUpdateEffect } from 'ahooks'
import { useNavigate, useParams } from 'react-router-dom'
import {
  SDrawerOrModal,
  SFuncModalFormRef,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'

import { getConfig } from './config.tsx'
import { AddOrEditProject } from './addOrEdit/project.tsx'
import { AddOrEditGeneral } from './addOrEdit/general.tsx'
import { AddOrEditProduct } from './addOrEdit/product.tsx'
import { StandardTable } from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step3/addOrEdit/standard'
import ExtraModal from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step3/addOrEdit/extra.tsx'
import { getSubPackTreeEditTree, idGenerate, subPackTreeTempDelete } from '@/services/product.ts'
import { message } from 'antd'
import { httpOrgList } from '@/services/homeService.ts'
import { apiData2Table } from '@/utils/data.ts'
import {
  findAndModifyTreeNode,
  traverseTree,
  treeToArray,
} from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/utils.ts'
import StandardDetail from '@/pages/baseProduct/generalManage/addOrEdit/index.tsx'
import { cloneDeep } from 'lodash-es'
import _ from 'lodash'
const StepPackageProduct = props => {
  const { submitInfo, options } = props
  const { id } = submitInfo
  const listRef = useRef<any>()
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const navigate = useNavigate()
  const filterDataRef = useRef<any>([])

  const config = getConfig()
  const [state, setState] = useSetState<any>({
    visible: false,
    type: 'PRD_PROJECT',
    record: {},
    btnLoading: false,
    dataSource: [],
    companyList: [],
    genItemId: '',
    isStandDrawer: false,
  })

  const [extraConfigChooseBustype, setExtraConfigChooseBustype] = useState('')
  const [editExtraConfig, setEditExtraConfig] = useState<Array<any>>([])
  const [editExtraConfigRecord, setEditExtraConfigRecord] = useState({})
  const [openExtraConfigModal, setOpenExtraConfigModal] = useState(false)

  useEffect(() => {
    getOptions()
  }, [submitInfo])
  useEffect(() => {
    console.log('submitInfo.treeNodes', submitInfo.treeNodes)
    setState({ dataSource: id ? submitInfo.treeNodes || [] : state.dataSource })
  }, [submitInfo.treeNodes])

  const getOptions = async () => {
    const companyList = await httpOrgList()
    setState({ companyList })
  }
  useEffect(() => {
    const showNameKey = listRef.current?.getSearch()?.getFieldValue('showNameKey')
    // 处理一下 没有子数据但是有展开符号
    const newDataSource = cloneDeep(state.dataSource)
    traverseTree(newDataSource, node => {
      if (node.children?.length === 0) {
        node.children = null
      }
    })
    if (showNameKey) {
      // 更新编辑过后的值放到过滤数组中
      filterDataRef.current = filterTreeByKeyword(newDataSource, showNameKey)
      listRef.current?.updateDataSource(filterDataRef.current, filterDataRef.current?.length)
    } else {
      listRef.current?.updateDataSource(newDataSource, newDataSource?.length)
    }
  }, [state.dataSource])

  useEffect(() => {
    if (!state.dataSource?.length) {
      return
    }
    const newTreeNodes = [...state.dataSource]
    findAndModifyTreeNode(newTreeNodes, editExtraConfigRecord.id, node => {
      // 修改父级 - parentNode为修改前父级对象
      if (node) {
        node.customizes = editExtraConfig
      }
    })
    setState({ dataSource: newTreeNodes })
  }, [editExtraConfig])

  const fetchList = () => {
    let showNameKey = listRef.current?.getSearch()?.getFieldValue('showNameKey')
    return new Promise((resolve, reject) => {
      if (!id && !state.dataSource.length) {
        listRef.current?.updateDataSource([])
        resolve([])
      } else {
        if (showNameKey) {
          // let filterData = filterTreeByKeyword(submitInfo.treeNodes, showNameKey)
          // resolve([...filterData])
          // listRef.current?.updateDataSource(filterData, filterData?.length)
          filterDataRef.current = filterTreeByKeyword(state.dataSource, showNameKey)
          resolve([...filterDataRef.current])
          listRef.current?.updateDataSource(filterDataRef.current, filterDataRef.current?.length)
        } else {
          resolve([...state.dataSource])
          listRef.current?.updateDataSource(state.dataSource, state.dataSource?.length)
        }
      }
    })
  }

  const filterTreeByKeyword = (treeData, keyword) => {
    const result: any = []
    const newArray = _.cloneDeep(treeToArray(treeData))
    newArray.forEach((item: any) => {
      if (item.dtlName.toLowerCase().includes(keyword.toLowerCase())) {
        item.children = null
        result.push(item)
      }
    })
    return result
  }

  const onAddOrEdit = ({
    record = {},
    type = 'PRD_PROJECT',
    isStandDrawer = false,
  }: Record<string, any>) => {
    setState({ visible: true, type, record: { ...record }, isStandDrawer })
  }

  const onClose = () => {
    setState({ visible: false, record: {} })
  }

  const onDel = record => {
    SMessage.confirm({
      onOk: () => {
        let newTreeNodes = [...state.dataSource]
        console.log(record, state.dataSource)
        if (!record.parentId || record.parentId == '0') {
          newTreeNodes = newTreeNodes.filter(item => item.id != record.id)
        } else {
          let parentId = record.parentId
          newTreeNodes.forEach((item: any) => {
            if (item.id == parentId) {
              item.children = item.children.filter((child: any) => child.id != record.id)
            }
          })
        }
        setState({ dataSource: newTreeNodes })
      },
    })
  }
  const onFinish = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      props.setLoading?.(true)
      console.log(state.dataSource, 'data--submit')
      const data = state.dataSource
      if (data && data.length) {
        resolve({
          treeNodes: data,
        })
      } else {
        resolve({
          treeNodes: [],
        })
      }
    })
  }
  if (props.editRef) props.editRef.onFinish = onFinish
  const onSubmit = () => {
    editRef.current.onFinish?.().then((res: any) => {
      // 手动添加 修改 树节点数据
      let treeNodes = listRef.current?.getDataSource()
      let dataSource = cloneDeep(state.dataSource || listRef.current?.getDataSource() || [])
      console.log('提交数据：res-->', res, dataSource, treeNodes)
      if (!res.id) {
        // 新增
        idGenerate({})
          .then(newId => {
            const res_ = { ...res, id: newId }
            if (res.parentId && res.parentId != '0') {
              // 有父级的情况
              findAndModifyTreeNode(dataSource, res.parentId, node => {
                if (node) {
                  node.children
                    ? !checkSameId(node.children, res_) && node.children.unshift(res_)
                    : (node.children = [res_])
                }
              })
            } else {
              // 添加到根节点
              !checkSameId(dataSource, res_) && dataSource.unshift(res_)
            }

            setState({ dataSource: [...dataSource] })
            onClose()
          })
          .finally(() => setState({ btnLoading: false }))
      } else {
        if (res.parentId && res.parentId != '0') {
          // 编辑二级节点
          let checkFlag = false
          // if (res.parentId !== res.oldParentId) {
          //   // 更换父级节点行为
          //   findAndModifyTreeNode(dataSource, res.parentId, parentNode => {
          //     // 修改父级 - parentNode为修改后父级对象
          //     if (parentNode) {
          //       const keys = Object.keys(res)
          //       const allKeys = keys.includes('children') ? [...keys] : [...keys, 'children']
          //       allKeys.forEach(key => {
          //         if (key === 'children') {
          //           if (parentNode[key]) {
          //             checkFlag = checkSameId(parentNode['children'], res)
          //             if (checkFlag) {
          //               // 取消更改 并且复原父级id
          //               res.parentId = res.oldParentId
          //               return
          //             }
          //             parentNode[key] =
          //               parentNode[key].length > 0 ? [...parentNode[key], res] : [res]
          //           } else {
          //             parentNode[key] = [res]
          //           }
          //         }
          //       })
          //     }
          //   })
          //   findAndModifyTreeNode(dataSource, res.oldParentId, parentNode => {
          //     // 修改父级 - parentNode为修改前父级对象
          //     if (parentNode && !checkFlag) {
          //       const keys = Object.keys(res)
          //       const allKeys = [...keys, 'children']
          //       allKeys.forEach(key => {
          //         if (key === 'children') {
          //           if (parentNode[key]) {
          //             parentNode[key] =
          //               parentNode[key].length > 0
          //                 ? parentNode[key].filter(item => item.id != res.id)
          //                 : []
          //           }
          //         }
          //       })
          //     }
          //   })
          // }
          if (res.parentId !== res.oldParentId) {
            // 修改父级 - parentNode为修改后父级对象 bn
            console.log(res, 'res')
            findAndModifyTreeNode(dataSource, res.parentId, parentNode => {
              if (parentNode) {
                const keys = Object.keys(res)
                const allKeys = keys.includes('children') ? [...keys] : [...keys, 'children']
                try {
                  allKeys.forEach(key => {
                    if (key === 'children') {
                      if (parentNode[key]) {
                        checkFlag = checkSameId(parentNode['children'], res)
                        if (checkFlag) {
                          // 取消更改 并且复原父级id
                          res.parentId = res.oldParentId
                          throw new Error('重复')
                        } else {
                          parentNode[key] =
                            parentNode[key].length > 0 ? [...parentNode[key], res] : [res]
                        }
                      } else {
                        parentNode[key] = [res]
                      }
                    }
                  })
                } catch (error) {
                  console.log(error, 'error')
                }
              }
            })
            // 修改原父级 - parentNode为修改前父级对象
            if (res.oldParentId == '0') {
              dataSource = dataSource.filter(item => item.id !== res.id)
            } else {
              findAndModifyTreeNode(dataSource, res.oldParentId, parentNode => {
                if (parentNode && !checkFlag) {
                  const keys = Object.keys(res)
                  const allKeys = [...keys, 'children']
                  allKeys.forEach(key => {
                    if (key === 'children') {
                      if (parentNode[key]) {
                        parentNode[key] =
                          parentNode[key].length > 0
                            ? parentNode[key].filter(item => item.id != res.id)
                            : []
                      }
                    }
                  })
                }
              })
            }
          }
          findAndModifyTreeNode(dataSource, res.id, node => {
            if (node) {
              const keys = Object.keys(res)
              keys.forEach(key => {
                node[key] = [
                  'children',
                  'createdBy',
                  'createdByName',
                  'createdTime',
                  'idPath',
                ].includes(key)
                  ? node[key]
                  : res[key]
              })
            }
          })
          setState({ dataSource: [...dataSource] })
        } else {
          // 编辑数据到根节点也要验重
          const data = dataSource.filter(item => item.id !== res.id)
          checkSameId(data, res)
          // 清除原数据
          findAndModifyTreeNode(dataSource, res.oldParentId, parentNode => {
            if (parentNode) {
              const keys = Object.keys(res)
              const allKeys = [...keys, 'children']
              allKeys.forEach(key => {
                if (key === 'children') {
                  if (parentNode[key]) {
                    parentNode[key] =
                      parentNode[key].length > 0
                        ? parentNode[key].filter(item => item.id != res.id)
                        : []
                  }
                }
              })
            }
          })
          if (res.parentId == '0' || !res.parentId) {
            // 恢复根节点子数据
            res.children = dataSource.find((el: any) => el.id === res.id).children
          }
          const newData = [
            ...data,
            {
              ...res,
              children: res.children,
              idPath: res.idPath,
              createdBy: res.createdBy,
              createdByName: res.createdByName,
              createdTime: res.createdTime,
            },
          ]
          setState({ dataSource: newData })
        }
        onClose()
        setState({ btnLoading: false })
      }
    })
  }
  /**
   * 校验当前空间下是否存在相同节点
   * @param upSpaceList 上级空间列表
   * @param node 当前节点
   */
  const checkSameId = (upSpaceList, node) => {
    let flag = upSpaceList.some((item: any) => item.busId === node.busId)
    if (flag) {
      message.error('当前空间下已存在相同数据')
    }
    return flag
  }
  // 跳转标配页面
  const clickToStandardPage = record => {
    // 手动添加
    if (record.object?.sonChooseType === 'GEN_STANDARD') {
      window.open(
        `/config/baseProduct/generalManage/standard-feature/${record.object?.id}?readOnly=true&&itemName=${record.dtlName}&&specialCode=${record.object?.specialCode}`
      )
    } else {
      // 规则配置
      onAddOrEdit({ type: 'standard', isStandDrawer: true, record: record })
    }
  }

  const handleOpenExtraConfigModal = (record: any, busType: any) => {
    // 要把通项本身配置带进去，同时记录原有数据
    setEditExtraConfigRecord(record)
    setEditExtraConfig(record.customizes || [])
    setOpenExtraConfigModal(true)
    setExtraConfigChooseBustype(busType)
  }

  const extensions = {
    request: { fetchList },
    events: {
      onAddProject: () => onAddOrEdit({ type: 'PRD_PROJECT' }),
      onAddGeneral: () => onAddOrEdit({ type: 'PRD_GEN_ITEM' }),
    },
    status: {
      projectBtnDisabled: () => state.dataSource?.some(item => item?.busType === 'PRD_GEN_ITEM'),
      generalBtnDisabled: () => state.dataSource?.some(item => item?.busType === 'PRD_PROJECT'),
    },
    customRender: {
      actionRender(_: null, record_: Record<string, any>): JSX.Element {
        const record = {
          ...record_,
        }
        const showExtraConfig =
          record_.busType === 'PRD_GEN_ITEM' || record_.busType === 'PRD_PRODUCT'
        return (
          <STableActions>
            <STableActions.SActionBtn onClick={() => onAddOrEdit({ record, type: record.busType })}>
              编辑
            </STableActions.SActionBtn>
            {record.busType === 'PRD_PROJECT' && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_GEN_ITEM',
                    record: { parentId: record.id, isMust: record.isMust },
                  })
                }
              >
                添加通项
              </STableActions.SActionBtn>
            )}
            {record.busType === 'PRD_PROJECT' && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_PRODUCT',
                    record: { parentId: record.id },
                  })
                }
              >
                添加产品
              </STableActions.SActionBtn>
            )}
            {record.busType === 'PRD_GEN_ITEM' && (
              <STableActions.SActionBtn onClick={() => clickToStandardPage(record)}>
                标配
              </STableActions.SActionBtn>
            )}
            {showExtraConfig ? (
              <STableActions.SActionBtn
                onClick={() => handleOpenExtraConfigModal(record, record_.busType)}
              >
                特殊配置
              </STableActions.SActionBtn>
            ) : null}
            <STableActions.SActionBtn danger onClick={() => onDel(record)}>
              删除
            </STableActions.SActionBtn>
          </STableActions>
        )
      },
      companyRender(_, record) {
        return <div>{record.shopList?.map(item => item.companyName).join('、')}</div>
      },
    },
  }
  const getTitle = () => {
    let titleBefore = ''
    if (state.type !== 'standard') {
      titleBefore = state.record.id ? '编辑' : '新增'
      props.readOnly && (titleBefore = '查看')
    }
    return titleBefore + modalObj[state.type].title
  }

  const modalObj = {
    PRD_PROJECT: {
      title: '项目',
      component: (
        <AddOrEditProject
          {...props}
          {...state}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onClose}
        />
      ),
    },
    PRD_GEN_ITEM: {
      title: '通项',
      component: (
        <AddOrEditGeneral
          {...props}
          {...state}
          options={options}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onClose}
        />
      ),
    },
    standard: {
      title: '标配',
      component: (
        <StandardDetail
          editRef={editRef.current}
          onCancel={onClose}
          isStand={true}
          fn={listRef.current?.reload}
          readOnly={true}
          setLoading={loading => setState({ loading })}
          record={state.record.object}
        />
      ),
    },
    PRD_PRODUCT: {
      title: '产品',
      component: (
        <AddOrEditProduct
          {...props}
          {...state}
          options={options}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onClose}
        />
      ),
    },
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
      <SDrawerOrModal
        width={600}
        antdProps={{ ...{ [state.type === 'standard' ? 'footer' : '']: null } }}
        title={getTitle()}
        onCancel={onClose}
        onOk={onSubmit}
        loading={state.btnLoading}
        open={state.visible}
      >
        {state.visible && modalObj[state.type].component}
      </SDrawerOrModal>
      {openExtraConfigModal && (
        <ExtraModal
          openModal={openExtraConfigModal}
          chooseType={extraConfigChooseBustype}
          editData={editExtraConfig}
          basicInfo={editExtraConfigRecord}
          setEditData={setEditExtraConfig}
          onClose={() => setOpenExtraConfigModal(false)}
        />
      )}
    </>
  )
}

export default StepPackageProduct
